import { FieldsFormData, TransactionData, AuthorData } from '../types';

export const getTransactionData = (
  fields: string[],
  itemId: string,
  transactionId: string,
  secret: string
) => `
query getTyckaDataForTransaction {
        item(id:"${itemId}"){
            name
            ${fields.join('\n')}
            imageUrls
            tags
            fields {
                name
                type
            }
        }
        transaction(
            id:"${transactionId}"
            secret:"${secret}") {
            items
            customFields {
                key
                value
            }
            reviewedItems
            authorId
        }
    }
`;

export const getRelatedProductsData = (
  fields: string[],
  itemIds: string[],
) => `
query getRelatedProductsData {
    itemsById(ids:[${itemIds.map(id => `"${id}"`).join(',')}]){
        id
        name
        ${fields.join('\n')}
        imageUrls
        tags
        fields {
            name
            type
        }
    }   
}
`;

export const getProductFields = () => `
query getHostedFormItemFields {
    __type(name:"ItemQueryResponse"){
        fields {
            name
        }
    }
}`;

export const createReview = (
  formData: FieldsFormData,
  transactionData: TransactionData,
  authorData: AuthorData
) => `
mutation createReview {
    createReview(
        itemId: "${transactionData.itemId}",
        authorId: "${authorData.authorId}",
        name: "${authorData.name}",
        email: "${authorData.email}",
        transactionId: "${transactionData.transactionId}",
        transactionSecret: "${transactionData.secret}",
        ${customFieldsBuilder(formData)}
    )
        {
            id 
            secret
        }
    }`;

const customFieldsBuilder = (formData: FieldsFormData) => {
  return Object.keys(formData)
    .map((key) => {
      if (key.toLocaleLowerCase().includes('rating')) {
        return `${key}: {
                            value: ${formData[key].value},
                            comment: "${formData[key].comment}"
                        }`;
      }
      if (typeof formData[key] === 'string') {
        return `${key}: "${formData[key]}"`;
      } else {
        return `${key}: ${formData[key]}`;
      }
    })
    .join(',\n');
};
